module.exports = __webpack_public_path__ + "static/CentralParkFacade-c6856dcf3020c6d05019f7d6b9e06ac9.jpg";